module.exports = __webpack_public_path__ + "static/smbunderwaterhero-db7fbe5374015e64c80600bad7a94632.gif";